import { createSelector } from "@reduxjs/toolkit";
import selectFiltersRaw from "./selectFiltersRaw";

export default createSelector(selectFiltersRaw, (filters) => filters.membersWorkoutsSearchTerm);
